import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {


    public static readonly PREVIOUS_USER = "previous_user";
    public static readonly IS_PERSONATE = "is_personate";
    public static readonly CURRENT_USER = "current_user";
    public static readonly USER_PERMISSIONS = "user_permissions";
    public static readonly ACCESS_TOKEN = "access_token";
    public static readonly ID_TOKEN = "id_token";
    public static readonly REFRESH_TOKEN = "refresh_token";
    public static readonly TOKEN_EXPIRES_IN = "expires_in";

    public static readonly REMEMBER_ME = "remember_me";


    public static readonly LANGUAGE = "language";
    public static readonly HOME_URL = "home_url";
    public static readonly THEME = "theme";
    public static readonly SHOW_DASHBOARD_STATISTICS = "show_dashboard_statistics";
    public static readonly SHOW_DASHBOARD_NOTIFICATIONS = "show_dashboard_notifications";
    public static readonly SHOW_DASHBOARD_TODO = "show_dashboard_todo";
    public static readonly SHOW_DASHBOARD_BANNER = "show_dashboard_banner";


    // ng-idle session timeout configuration [All Time Confuration in Seconds format]
    public static readonly IDLE_TIME = 1140;
    public static readonly IDLE_TIME_OUT_DURATION = 60;
    public static readonly IDLE_KEEP_ALIVE_INTERVAL = 450;


    public static readonly EXTEND_YEARS = 1;   

    //GAS
    public static readonly GASMAX = "GasMax";
    public static readonly GASMIN = "GasMin";
    public static readonly GASCHARTDATA = "GaschartData";
    public static readonly GASCHARTLABELS = "GaschartLabels";

    //Electricity
    public static readonly ELECTRICITYMAX = "ElectricityMax";
    public static readonly ELECTRICITYMIN = "ElectricityMin";
    public static readonly ELECTRICITYCHARTDATA = "ElectricitychartData";
    public static readonly ELECTRICITYCHARTLABELS = "ElectricitychartLabels";

    //GasTwo
    public static readonly GASTWOMAX = "GastwoMax";
    public static readonly GASTWOMIN = "GatwoMin";
    public static readonly GASTWOCHARTDATA = "GastwochartData";
    public static readonly GASTWOCHARTLABELS = "GastwochartLabels";

    //belpex
    public static readonly BELPEXMAX = "BelpexMax";
    public static readonly BELPEXMIN = "BelpexMin";
    public static readonly BELPEXCHARTDATA = "BelpexchartData";
    public static readonly BELPEXCHARTLABELS = "BelpexchartLabels";

    //CoTwo
    public static readonly COTWOMAX = "CotwoMax";
    public static readonly COTWOMIN = "CotwoMin";
    public static readonly COTWOCHARTDATA = "CotwochartData";
    public static readonly COTWOCHARTLABELS = "CotwochartLabels";

    //COAL
    public static readonly COALMAX = "CoalMax";
    public static readonly COALMIN = "CoalMin";
    public static readonly COALCHARTDATA = "CoalchartData";
    public static readonly COALCHARTLABELS = "CoalchartLabels"; 

    //oil 
    public static readonly OILMAX = "OilMax";
    public static readonly OILMIN = "OilMin";
    public static readonly OILCHARTDATA = "OilchartData";
    public static readonly OILCHARTLABELS = "OilchartLabels";


    //GAS Trial
    public static readonly GASTRIALMAX = "GasTrialMax";
    public static readonly GASTRIALMIN = "GasTrialMin";
    public static readonly GASTRIALCHARTDATA = "GasTrialchartData";
    public static readonly GASTRIALCHARTLABELS = "GasTrialchartLabels";

    //Electricity Trial
    public static readonly ELECTRICITYTRIALMAX = "ElectricityTrialMax";
    public static readonly ELECTRICITYTRIALMIN = "ElectricityTrialMin";
    public static readonly ELECTRICITYTRIALCHARTDATA = "ElectricityTrialchartData";
    public static readonly ELECTRICITYTRIALCHARTLABELS = "ElectricityTrialchartLabels";

    //GasTwo Trial
    public static readonly GASTWOTRIALMAX = "GastwoTrialMax";
    public static readonly GASTWOTRIALMIN = "GatwoTrialMin";
    public static readonly GASTWOTRIALCHARTDATA = "GastwoTrialchartData";
    public static readonly GASTWOTRIALCHARTLABELS = "GastwoTrialchartLabels";

    //belpex Trial
    public static readonly BELPEXTRIALMAX = "BelpexTrialMax";
    public static readonly BELPEXTRIALMIN = "BelpexTrialMin";
    public static readonly BELPEXTRIALCHARTDATA = "BelpexTrialchartData";
    public static readonly BELPEXTRIALCHARTLABELS = "BelpexTrialchartLabels";

    //CoTwo Trial
    public static readonly COTWOTRIALMAX = "CotwoTrialMax";
    public static readonly COTWOTRIALMIN = "CotwoTrialMin";
    public static readonly COTWOTRIALCHARTDATA = "CotwoTrialchartData";
    public static readonly COTWOTRIALCHARTLABELS = "CotwoTrialchartLabels";

    //COAL Trial
    public static readonly COALTRIALMAX = "CoalTrialMax";
    public static readonly COALTRIALMIN = "CoalTrialMin";
    public static readonly COALTRIALCHARTDATA = "CoalTrialchartData";
    public static readonly COALTRIALCHARTLABELS = "CoalTrialchartLabels"; 

    //oil Trial
    public static readonly OILTRIALMAX = "OilTrialMax";
    public static readonly OILTRIALMIN = "OilTrialMin";
    public static readonly OILTRIALCHARTDATA = "OilTrialchartData";
    public static readonly OILTRIALCHARTLABELS = "OilTrialchartLabels";

    //Application Version
    public static readonly APPLICATIONVERSION = "ApplicationVersion";
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/db-Keys.ts